import React, { useEffect, useState, useContext, useRef, useCallback } from "react";
import { TabView, TabPanel } from 'primereact/tabview';
import { useWeb3React } from "@web3-react/core";
import Dashboard from "./subcomponents_refuel/Dashboard";
import Admin from "./subcomponents_refuel/Admin";
import ContractContext from '../ContractContext'; //Required for all new dApps
import DataContext from "../DataContext"; //Required for all new dApps
import { Toast } from 'primereact/toast'
import Web3 from "web3";

import {
  infoOutlineStyle, cardOutlineHeaderStyle, cardOutlineStyle,
} from "./subcomponents/TileStyles";

import { Card } from 'primereact/card';

import { getTokenPrice } from '../utils';

// Replace pricing for specified tokens with alternate address pricing
const replacements = {
  "0x0Cab564F58AD72877F0bc3Cd52468860294c15a6": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  "0x904B4224acA463666E98f21cC8C54f8D423f6648": "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
  "0xDfD077c9C2F488e5CFeD14EbBcb7B8E056334EbA": "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
  "0x3834303483f139c26bc282528aDee6b7Da103D54": "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
  "0x09b22c55436cb5F4F91306e632e0a5F0DD031BA8": "0x570a5d26f7765ecb712c0924e4de545b89fd43df",
  "0x2a5D78825Bf470e70f9B62F2BCE8483941c11132": "0x2859e4544C4bB03966803b044A93563Bd2D0DD4D",
  "0x2761c609f3DbA79FFb34d28ab8d9cc2FF381fD3A": "0x3ee2200efb3400fabb9aacf31297cbdd1d435d47",
  "0xb014728C841D8Ccca6C236fE04B274D206cc60D0": "0xba2ae424d960c26247dd6c32edc70b295c744c43",
  "0x58291c58A2c4AEc7Ad24BaA87988dFc39f3FBC25": "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
};


export const Refuel = () => {
  const { library, account, activate, deactivate, active, error } = useWeb3React();
  const contractContext = useContext(ContractContext);
  const contracts = contractContext.contracts;
  const dataContext = useContext(DataContext);
  const { data, setData } = dataContext;
  const [dbError, setDbError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); // added state for custom error message
  const [smartCodeData, setSmartCodeData] = useState({});
  let toast = useRef(null);

  const isWalletConnected = () => account !== null;

  //console.log(useWeb3React());


  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (isWalletConnected() && contracts) {
      getData();
      const timer = setInterval(getData, 120000);
      return () => clearInterval(timer);
    }
  }, [account, contracts]);



  const getContractData = useCallback(async (contract, account) => {
    return await contract.methods.getRocketData(account).call();
  }, []);

  const getTokenPoolData = useCallback(async (contract, account) => {
    return await contract.methods.getTokenPoolData(account).call();
  }, []);

    const getTokenPoolDataPaginated = async (contract, account, batchSize = 100) => {
    try {
      const { 0: totalBatches } = await contract.methods.getTotalCalls(batchSize).call();
      const results = [];

      for (let page = 0; page < totalBatches; page++) {
        const batch = await contract.methods.getTokenPoolDataBatch(account, page).call();
        results.push(...batch);
      }

      return results;
    } catch (err) {
      console.error("getTokenPoolDataPaginated failed:", err);
      return [];
    }
  };

  const getTokenBnbValueSmartRewards = async (contract, token) => {
    return await contract.methods.getTokenBnbValueSmartRewards(token.address, true, true).call();
  }

  const getLiquidityPairs = async (contract, token) => {
    return await contract.methods.getLiquidityPairsInfo(token.address, true, true).call();
  }

  const getAllSmartRewardsBnbValues = useCallback(async (contract) => {
    return await contract.methods.getAllSmartRewardsBnbValues().call();
  }, []);

  const getAllSmartRewardsUsdValues = useCallback(async (contract) => {
    return await contract.methods.getAllSmartRewardsUsdValues().call();
  }, []);

  const getSmartCodeData = useCallback(async () => {
    const result = await contracts.smartCodes.methods.smartCodeData(account).call();
    //console.log("getSmartCodeData:", result);
    return result;
  }, [contracts, account]);

  const [bnbBalance, setBnbBalance] = useState(0);


  useEffect(() => {
    if (!library) return;
    const web3 = new Web3(library.provider);
    web3.eth.getBalance(account).then((balance) => {
      //console.log("balance:", balance);
      setBnbBalance(balance);
    });
  }, [library, account, data]);

  useEffect(() => {
    // console.log("bnbBalance:", bnbBalance); 
  }, [bnbBalance]);

  useEffect(() => {
    const fetchSmartCodeData = async () => {
      const result = await getSmartCodeData();
      setSmartCodeData(result);
    };

    if (data && contracts.smartCodes) {
      fetchSmartCodeData();
    }
  }, [data, contracts]);




  const createTokensList = useCallback((tokenPoolData, pricingData) => {
    return tokenPoolData.map((tokenData) => {
      if (!tokenData) return undefined;
      const tokenAddress = tokenData._tokenAddress.toLowerCase();
      const pricingToken = pricingData[tokenAddress];
      let tokenPrice = pricingToken ? pricingToken.usd : undefined;
      return {
        value: tokenData._tokenAddress,
        label: tokenData._symbol,
        rocketFiSubscribed: tokenData._shareCount / (10 ** 9),
        totalDistributed: tokenData._totalDistributed,
        decimals: tokenData._decimals,
        poolID: tokenData._poolID,
        unclaimedAmount: tokenData._unclaimedAmount,
        claimedAmount: tokenData._claimedAmount,
        routerAddress: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        address: tokenData._tokenAddress,
        price: tokenPrice,
        reflectionPoolAddress: tokenData._reflectionPoolAddress,
        balanceOfHolder: tokenData._balanceOfHolder,
        totalSupply: tokenData._totalSupply,
      };
    });
  }, []);

  useEffect(() => {
    if (dbError && toast) {
      toast.current.show({ severity: 'warn', summary: 'Warning Message', detail: errorMessage, life: 5000 }); // display the custom error message
    }
  }, [dbError, errorMessage]);



  const getPrimaryData = useCallback(async () => {
    const [_contractDataRes, _tokenPoolDataRes] = await Promise.allSettled([
        getContractData(contracts.rp_rocketFiOracle, account),
        getTokenPoolDataPaginated(contracts.rp_rewardPacksOracle, account),
      ]);

      const contractDataRp = _contractDataRes.status === 'fulfilled' ? _contractDataRes.value : [];
    const tokenPoolDataRp = _tokenPoolDataRes.status === 'fulfilled' ? _tokenPoolDataRes.value : [];


    const activePoolAddress = [
      ...new Set(
        tokenPoolDataRp.map((obj) => obj._tokenAddress)
      ),
    ];

    const str1 = activePoolAddress.toString();


    return {
      contractData: contractDataRp,
      tokenPoolData: tokenPoolDataRp,
      activePoolAddress: str1,
    };
  }, [contracts, account]);

    const getDatabaseData = useCallback(async (_url, _endPoint, _parms) => {
      const data = await fetch(_url + _endPoint + "?" + _parms, {
        method: "GET",
        headers: {
          //'Authorization': bearer,
          "x-floatie-api-key": "hrNqBjEIOaMLvY7SNXQtYOca5LvlQPn6O3oduqOwg3L3up20",
          "x-floatie-api-secret": "O3Ux1HsMC8Qcd0rb",
          "Content-Type": "application/json",
        },
      });

      var jsondata = await data.json();
      return jsondata.result;
    }, []);

    const getSecondaryData = useCallback(async (activePoolAddress, _tokenPoolData, pricingData) => {
      // Normalize activePoolAddress into an array of addresses
      let addressesArray = [];
      if (!activePoolAddress) {
        addressesArray = [];
      } else if (Array.isArray(activePoolAddress)) {
        addressesArray = activePoolAddress.map(a => a.toString().trim()).filter(Boolean);
      } else {
        addressesArray = activePoolAddress.toString().split(',').map(a => a.trim()).filter(Boolean);
      }

      if (addressesArray.length === 0) {
        setErrorMessage("Database did not return any data"); // set custom error message when no addresses provided
        setDbError(true);
        return { dbData: [], tokensList: createTokensList(_tokenPoolData, pricingData) };
      }

      // Batch requests with max batch size 100
      const batchSize = 100;
      const batches = [];
      for (let i = 0; i < addressesArray.length; i += batchSize) {
        batches.push(addressesArray.slice(i, i + batchSize));
      }

      const dbPromises = batches.map((batch) =>
        getDatabaseData(
          "https://api.rocketfi.app/v1/",
          "tokens",
          "addresses=" + batch.join(",") + "&limit=" + batch.length
        )
      );

      const results = await Promise.all(dbPromises);
      // Flatten results (each result is expected to be an array)
      const combined = results.flat();

      if (!combined || combined.length === 0) {
        setErrorMessage("Database did not return any data"); // set custom error message when _dbData doesn't return anything
        setDbError(true);
      } else {
        const _tokensList = createTokensList(_tokenPoolData, pricingData);
        //console.log("tokensList:", _tokensList);
        return {
          dbData: combined,
          tokensList: _tokensList,
        };
      }
    }, [createTokensList]);



  const getPricingData = useCallback(async () => {
    const oracle = contracts.liquidityOraclePaginator;
    const BATCH_SIZE = 100;
    let pricingData = {};
  
    try {
      const { 0: totalBatches } = await oracle.methods.getActivePoolTotalCalls(BATCH_SIZE).call();
  
      for (let page = 0; page < totalBatches; page++) {
        const bnbBatch = await oracle.methods.getAllSmartRewardsBnbValuesBatch(page, BATCH_SIZE).call();
        const usdBatch = await oracle.methods.getAllSmartRewardsUsdValuesBatch(page, BATCH_SIZE).call();
  
        for (let i = 0; i < bnbBatch[0].length; i++) {
          const addr = bnbBatch[0][i].toLowerCase();
          const bnb = Number(bnbBatch[1][i]) / 1e18;
          const usdIndex = usdBatch[0].findIndex(x => x.toLowerCase() === addr);
          const usd = usdIndex !== -1 ? Number(usdBatch[1][usdIndex]) / 1e18 : 0;
  
          pricingData[addr] = { bnb, usd };
        }
      }
  
      // Hardcoded USD pegs
      pricingData["0x2e3b6906b976ab8da82228e0569b3ef6ea1e8cc6"] = { usd: 1.0 };
      pricingData["0x27874a586bafaf54d4cd0aae368ad9569d06d115"] = { usd: 1.0 };
  
      Object.entries(replacements).forEach(([original, alternate]) => {
        const orig = original.toLowerCase();
        const repl = alternate.toLowerCase();
        if (pricingData[orig] && pricingData[repl]) {
          pricingData[orig] = { ...pricingData[repl] };
        }
      });
  
      return { pricingData };
    } catch (err) {
      console.error("Paginated getPricingData failed:", err);
      return { pricingData };
    }
  }, [contracts]);




  const getData = useCallback(async () => {
    if (!isWalletConnected() || !contracts || !contracts.rp_rocketFiOracle) {
      //console.error("Please connect to a wallet before interacting with the contract.");
      return;
    }

    //console.log("getData()");

    try {
      // get pricing data
      const pricingData = await getPricingData();
      //console.log("pricingData:", pricingData);
      const primaryData = await getPrimaryData();
      //console.log("primaryData:", primaryData);
      const secondaryData = await getSecondaryData(primaryData.activePoolAddress, primaryData.tokenPoolData, pricingData.pricingData);

      const newData = {
        ...data,
        ...primaryData,
        ...secondaryData,
        ...pricingData,
      };

      setData(newData); // set the data state only once with the updated data
    } catch (err) {
      console.error("An error occurred while fetching contract data:", err);
    }
  }, [contracts, account]);

  useEffect(() => {
    if (data?.activePoolAddress && data?.tokenPoolData && data?.pricingData)
      getAdditionalData();

  }, [data?.activePoolAddress, data?.tokenPoolData, data?.pricingData]);

  const getAdditionalData = useCallback(async () => {
    if (!isWalletConnected() || !contracts || !contracts.rp_rocketFiOracle) {
      //console.error("Please connect to a wallet before interacting with the contract.");
      return;
    }

    try {
      const secondaryData = await getSecondaryData(data.activePoolAddress, data.tokenPoolData, data.pricingData);
      //console.log("secondaryData:", secondaryData);
      const newData = {
        ...data,
        ...secondaryData,
      };

      setData(newData); // set the data state only once with the updated data
    } catch (err) {
      console.error("An error occurred while fetching contract data:", err);
    }

  }, [contracts, account, data]);


  const rocketFiPrice = getTokenPrice(data?.tokensList, "ROCKETFI");



  return (

    <>
      {!(active)
        ?

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px', marginTop: '10px', marginLeft: '10px', marginRight: '10px' }}>

          <Card title={
            <div style={cardOutlineHeaderStyle}>Welcome to the</div>
          }
            style={cardOutlineStyle}>
            <div style={infoOutlineStyle}>
              Refuel Rewards dApp
            </div>
          </Card>
        </div>
        :
        <>
          <Toast ref={toast} />
          <TabView className="my-tabview" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            <TabPanel header="Dashboard">
              <Dashboard data={data} getData={getData} account={account} rocketFiPrice={rocketFiPrice} bnbBalance={bnbBalance} smartCodeData={smartCodeData} />
            </TabPanel>
            <TabPanel header="Payments & Rewards" >
              <Admin data={data} getData={getData} account={account} rocketFiPrice={rocketFiPrice} bnbBalance={bnbBalance} />
            </TabPanel>
          </TabView>
        </>}
    </>
  );
};

export default React.memo(Refuel);
